import styled from 'styled-components';

export const Button = styled.div`
    cursor: pointer;
    color: #3C50E0;
    font-size: 16px;
    font-weight: 700;
    margin-left: 20px;
`;
